module.exports = __webpack_public_path__ + "static/media/method-2a.9f6538eb.png";